// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"34":"97e17fe6","208":"22fb4f8c","218":"078990f6","242":"177fdac6","380":"eff579cd","760":"078990f6","772":"ec72ff7d","848":"e6e70e8e","960":"e1fe54a2"}[chunkId] + ".chunk.css";
};